var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"business-contact-category-create","title":"Kategorie erstellen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('business-contact-category-form',{attrs:{"businessContactCategory":_vm.businessContactCategory,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }